
varying float vWobble;
uniform vec3 uColorA;
uniform vec3 uColorB;

void main()
{
    float colorMix = smoothstep(-1.0, 1.0, vWobble);
    csm_DiffuseColor.rgb = vec3(mix(uColorA, uColorB, colorMix));

    // // Mirro step
    // csm_Metalness = step(0.25, color);
    // csm_Roughness = 1.0 - csm_Metalness;

    // //Shiny tip
    // csm_Roughness = 1.0 - colorMix;
}